// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"1f4306c5","62":"eee97fff","152":"74b40ed0","170":"1b77642d","453":"e79babd8","507":"877af3f3","559":"37df018c","607":"c543b518","813":"e917cf7c","848":"e3b45fb8","887":"88ac6e39","972":"0f1dd0b9"}[chunkId] + ".chunk.js";
};